module.exports = __webpack_public_path__ + "static/Full Stack engineer-35f5f24bbd4058c26a5fa0742c0925c0.png";